import { MantineColor, Badge } from '@mantine/core'
import { SpeciStatus } from '@loom-api-types'

export enum SpeciStatusOptionsLabels {
  Completed = 'Completed',
  InProgress = 'In Progress',
}

type SpeciStatusDisplayProps = {
  speciStatus?: SpeciStatus | null
}

export function SpeciStatusDisplay({ speciStatus }: SpeciStatusDisplayProps) {
  if (!speciStatus) {
    return <></>
  }

  let text: string = 'Unknown'
  let bgColour: MantineColor = 'red.2'

  switch (speciStatus) {
    case SpeciStatus.InProgress:
      text = SpeciStatusOptionsLabels.InProgress
      bgColour = 'orange.2'
      break
    case SpeciStatus.Completed:
      text = SpeciStatusOptionsLabels.Completed
      bgColour = 'green.2'
      break
  }

  return (
    <Badge c='black' color={bgColour} fw={600} aria-label={`Status ${text}`}>
      {text}
    </Badge>
  )
}
